import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

/**
 * Composant pour rediriger les utilisateurs authentifiés selon leur rôle
 * Admin -> /admin
 * Cyber -> /cyber-dashboard
 */
const AuthRedirect: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (user.role === 'cyber') {
    return <Navigate to="/cyber-dashboard" />;
  }

  return <Navigate to="/admin" />;
};

export default AuthRedirect;
